import { jsxs as b, jsx as a } from "react/jsx-runtime";
import { forwardRef as h, cloneElement as B } from "react";
import g from "classnames";
import { selectIconButtonColor as l } from "./index.es672.js";
import N from "./index.es673.js";
import n from "./index.es674.js";
import { getButtonAriaLabel as I } from "./index.es675.js";
import { ButtonLoadingIndication as T } from "./index.es676.js";
import { UtilityChevronIcon as C } from "./index.es422.js";
const x = "icon-button-component", w = h(
  ({
    variant: o = "primary-brand",
    disabled: t = !1,
    Icon: m,
    size: s,
    chevron: c,
    isLoading: r = !1,
    testId: e = x,
    isOnGrayBackground: i,
    "aria-label": p,
    ...u
  }, f) => {
    const y = g(N.button, n["button-icon"], {
      [n.isOnGrayBackground]: i,
      [n.loading]: r
    }), d = l(o, t);
    return /* @__PURE__ */ b(
      "button",
      {
        className: y,
        disabled: t,
        "data-testid": e,
        "data-pl-size": s,
        "data-pl-variant": o,
        ref: f,
        "aria-label": I(p, r),
        ...u,
        children: [
          /* @__PURE__ */ a(
            T,
            {
              isLoading: r,
              variant: o === "ghost" ? "secondary-gray" : o,
              testId: e
            }
          ),
          !r && B(m, {
            outline: d,
            color: (o === "secondary-gray" || o === "ghost") && !t ? "gray" : "outline"
          }),
          c && /* @__PURE__ */ a(
            "div",
            {
              className: n.chevron,
              "data-testid": `${e}-chevron`,
              "data-type": "chevron",
              children: /* @__PURE__ */ a(
                C,
                {
                  type: "normal",
                  direction: c.direction,
                  outline: l(o, t)
                }
              )
            }
          )
        ]
      }
    );
  }
);
export {
  x as ICON_BUTTON_DEFAULT_TESTID,
  w as IconButton
};
//# sourceMappingURL=index.es12.js.map
